import { render } from "./AccountSettingsModal.vue?vue&type=template&id=2d8b898a&ts=true"
import script from "./AccountSettingsModal.vue?vue&type=script&lang=ts"
export * from "./AccountSettingsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__